<div class="container-fluid common-pages-banner">
    <div class="container">
        <div class="tg-theme-heading">
            <h1 class="h1tags">Help Center</h1>
        </div>
    </div>
</div>


<div class="container-fluid paddEqual">
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-12 offset-md-3">
                <div class="row rowLeftM">
                    <div class="col-12 pd-0 usersformms">
                        <div class="row marginZero">
                            <div class="col-12">
                                <div class="col-12 usersHeader">
                                    <h4 class="card-title">Have Questions?</h4>
                                </div>
                                <form class="col-12 pd-0" [ngClass]="{'white-layer':helpcenterLoader}" [formGroup]="helpcenter" (ngSubmit)="helpcenterEnd()" style="position: relative;">
                                    <p style="font-size: 14px;color:green;font-weight:300;text-align: left;" *ngIf="helpcenterSuccessMsg"><i class="ti-face-smile" aria-hidden="true"></i>&nbsp;<span [innerHtml]="helpcenterSuccessMsg"></span></p>
                                    <p style="font-size: 14px;color:#db0c0c;font-weight:300;text-align: left;" *ngIf="helpcenterErrorMsg"><i class="ti-face-sad" aria-hidden="true"></i>&nbsp;<span [innerHTML]="helpcenterErrorMsg"></span></p>
                                    <div class="form-group">
                                        <label>Name</label>
                                        <input type="text" class="form-control" required formControlName="name" placeholder="Enter Name" (keypress)="validateAlpha($event)">
                                        <div class="error-msg" *ngIf="helpcenterControl.name.touched && helpcenterControl.name.errors">
                                            <div style="font-size: 12px">Enter name</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Email-Id</label>
                                        <input type="email" class="form-control" required formControlName="email" placeholder="Enter Email-Id">
                                        <div class="error-msg" *ngIf="helpcenterControl.email.touched && helpcenterControl.email.errors">
                                            <div style="font-size: 12px">Enter valid email id</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Phone Number</label>
                                        <input type="tel" class="form-control" required formControlName="phone" placeholder="Enter Phone Number" (keypress)="numberOnly($event,10)">
                                        <div class="error-msg" *ngIf="helpcenterControl.phone.touched && helpcenterControl.phone.errors">
                                            <div style="font-size: 12px">Enter valid phone number</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Subject</label>
                                        <input type="text" class="form-control" required formControlName="subject" placeholder="Enter Subject">
                                        <div class="error-msg" *ngIf="helpcenterControl.subject.touched && helpcenterControl.subject.errors">
                                            <div style="font-size: 12px">Enter subject</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Message</label>
                                        <textarea class="form-control" required formControlName="message" placeholder="Enter Message"></textarea>
                                        <div class="error-msg" *ngIf="helpcenterControl.message.touched && helpcenterControl.message.errors">
                                            <div style="font-size: 12px">Enter message</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <button class="btn btn-danger" type="submit">Submit  <div class="box" *ngIf="helpcenterLoader"><div class="loader-13"></div></div></button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>